<script>
import {mapState, mapActions} from "vuex";
import formatMoney from "../../mixins/formatMoney";

export default {
  name: "AddToCart",
  mixins: [formatMoney],
  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapState("product", [
      "quantity",
      "selectedVariant",
      "quantity",
      "quantityModification",
    ]),

    soldOut() {
      if (!this.selectedVariant) return false;
      return !this.selectedVariant.available;
    },

    disabled() {
      return this.loading || !this.selectedVariant || this.soldOut;
    },
  },

  methods: {
    ...mapActions("cart", ["addItem"]),

    handleSubmit(e) {
      if (this.isLoading || !this.selectedVariant) return;
      e.preventDefault();

      let propertiesConfig = {};

      if (this.quantityModification?.quantity) {
        propertiesConfig = {
          properties: {
            _quantityModification: this.quantityModification,
          },
        };
      }

      const options = Object.assign(
        {
          id: this.selectedVariant.id,
          quantity: this.quantity,
        },
        propertiesConfig,
      );

      this.loading = true;
      this.addItem(options).then(() => {
        this.loading = false;
      });
    },

    buttonText() {
      const buttonTexts = {
        default: "Add To Cart",
        loading: "Adding...",
        soldOut: "Sold Out",
        selection: "Make A Selection",
      };

      let price = this.selectedVariant.price;

      if (this.quantityModification?.quantity) {
        price = this.selectedVariant.price * this.quantityModification.quantity;
      }

      if (Object.keys(this.selectedVariant).length === 0) {
        return buttonTexts.selection;
      } else {
        return `${buttonTexts.default} - ${this.formatMoney(price)}`;
      }
    },
  },

  render() {
    return this.$slots.default({
      loading: this.loading,
      disabled: this.disabled,
      addToCart: this.handleSubmit,
      soldOut: this.soldOut,
      buttonText: this.buttonText,
      selectedVariant: this.selectedVariant,
    });
  },
};
</script>
